import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  customVariables: '../styles/variables.scss',
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#0043F7',
        secondary: '#7581F2',
        accent: '#8596a4',
        error: '#B3261E',
        info: '#2196F3',
        success: '#3ed078',
        warning: '#A26C00'
      }
    }
  }
})
